/** Browser navigation is separate from the server's recorded consent decision. */
export function returnToOAuthClient(url: string) {
  window.location.assign(url)
}
